import {useLazyQuery, useMutation, useQuery} from '@apollo/client';
import {mediaFileQueries, mediaFilesMutations} from 'api';
import {MediaFileModel, MediaFileCreateRequestModel, ResponseViewModel, GetAllMediaFilesRequest} from 'models';

export const useCreateMediaFiles = () => {
    const [createMedieFile, {data, loading}] = useMutation<
        {storeMediaFiles: MediaFileModel[]},
        MediaFileCreateRequestModel
    >(mediaFilesMutations.STORE_MEDIA_FILES, {
        context: {
            headers: {
                'GraphQL-preflight': '1',
            },
        },
    });

    return {
        createMedieFile,
        createMedieFileResponse: data?.storeMediaFiles,
        createMedieFileLoading: loading,
    };
};
export const useGetAllMediaFiles = () => {
    const [getAllMediaFiles, {data, loading}] = useLazyQuery<
        {
            mediaFiles: MediaFileModel[];
        },
        GetAllMediaFilesRequest
    >(mediaFileQueries.GET_ALL_MEDIA_FIELDS, {
        fetchPolicy: 'no-cache',
    });

    return {
        getAllMediaFiles,
        getAllMediaFilesResponse: data?.mediaFiles,
        getAllMediaFilesLoading: loading,
    };
};
export const useDeleteMediaFilesByIds = () => {
    const [deleteMediaFilesByIds, {data, loading}] = useMutation<
        {
            deleteMediaFilesByIds: ResponseViewModel<string>;
        },
        {ids: string[]}
    >(mediaFilesMutations.DELETE_MEDIA_FILES_BY_IDS, {
        context: {
            headers: {
                'GraphQL-preflight': '1',
            },
        },
    });

    return {
        deleteMediaFilesByIds,
        deleteMediaFilesByIdsResponse: data?.deleteMediaFilesByIds,
        deleteMediaFilesByIdsLoading: loading,
    };
};

export const useDeleteMediaFilesByObjectIdAndObjectType = () => {
    const [deleteMediaFilesByObjectIdAndObjectType, {data, loading}] = useMutation<
        {
            deleteMediaFilesByObjectIdAndObjectType: ResponseViewModel<string>;
        },
        {objectId: string; objectType: string}
    >(mediaFilesMutations.DELETE_MEDIA_FILES_BY_OBJECT_ID_AND_OBJECT_TYPE, {
        context: {
            headers: {
                'GraphQL-preflight': '1',
            },
        },
    });

    return {
        deleteMediaFilesByObjectIdAndObjectType,
        deleteMediaFilesByObjectIdAndObjectTypeResponse: data?.deleteMediaFilesByObjectIdAndObjectType,
        deleteMediaFilesByObjectIdAndObjectTypeLoading: loading,
    };
};
